import layout from '@/components/common/layout';
import classList from '../views/class/list';
import classCreate from "../views/class/create";

export default [
    {
        path: '/class',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "班级列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'class_list',// 子选项
                    }
                },
                component: classList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增班级",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'class_list',// 子选项
                    }
                },
                component: classCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑班级",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'class_list',// 子选项
                    }
                },
                component: classCreate,
            },
        ]
    },
];
